export default __webpack_public_path__ + "static/media/activeHomeIcon.10e4e136.svg";